import { hydrate } from "@propublica/pp-svelte/util/hydrate-baker.mjs";
import enhanceShortenedTables from "@propublica/pp-v5-shared/src/js/table.shortened.js";

import * as componentClasses from "./svelte-components.js";

import subnav from "./subnav.js";
subnav.init();

// @ts-ignore (TODO: Fix type problems with componentClasses)
hydrate(componentClasses);
enhanceShortenedTables();
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Flip } from "gsap/Flip";

gsap.registerPlugin(Flip, ScrollTrigger);
// Define isMobile globally
let isMobile = window.innerWidth <= 768;

document.addEventListener("DOMContentLoaded", (event) => {
    if (isMobile) {
        cardShowingMobile();
    } else {
        cardShowing();
    }
    cardAnim();
});

function cardShowing() {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".media-container",
            start: "top top",
            end: "+=2500",
            scrub: 1,
        },
    });

    tl.to("#opener-card-5", {
        autoAlpha: 1,
    })
        .to("#opener-card-4", {
            autoAlpha: 1,
        })
        .to("#opener-card-3", {
            autoAlpha: 1,
        })
        .to("#opener-card-6", {
            autoAlpha: 1,
        })
        .to("#opener-card-1", {
            autoAlpha: 1,
        })
        .to("#opener-card-2", {
            autoAlpha: 1,
        })

        .to(".media-container", { autoAlpha: 0 });
}

function cardShowingMobile() {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".media-container",
            start: "top top",
            end: "+=1900",
            scrub: 1,
        },
    });

    tl.to("#opener-card-5", {
        autoAlpha: 1,
    })
        .to("#opener-card-4", {
            autoAlpha: 1,
        })
        .to("#opener-card-3", {
            autoAlpha: 1,
        })
        .to("#opener-card-6", {
            autoAlpha: 1,
        })

        .to(".media-container", { autoAlpha: 0 });
}

function cardAnim() {
    const cardData = [
        {
            name: "Denise Maratos",
            position: "Psychologist",
            location: "Santa Monica, California",
            quote: "“They questioned if a client has the diagnosis that I specialize in.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Maratos-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left a network in 2022",
        },
        {
            name: "Beth Green",
            position: "Psychologist",
            location: "San Diego, California",
            quote: "“Fresh grief issues like the death of the spouse, they would still say things like, ‘When will you be terminating treatment?’”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Green-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left a network in 2018",
        },

        {
            name: "Ninette Larson",
            position: "Therapist",
            location: "Walnut Creek, California",
            quote: "“I had a patient who was a stroke survivor and couldn’t speak fast, so sessions took an hour.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Larson-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left a network in 2020",
        },
        {
            name: "Elizabeth Fisher",
            position: "Psychologist",
            location: "Tampa, Florida",
            quote: "“I work with trauma clients, and I can’t open that trauma up and put it back in a box in 45 minutes.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Fisher-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left a network in 2023",
        },
        {
            name: "Heidi Koss",
            position: "Therapist",
            location: "Woodinville, Washington",
            quote: "“They started doing this cat-and-mouse game where about every three months they would change a billing code. It was just like, ‘Oh shit, they’re trying to overtly game the system, and they’re trying to delay paying out.’”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Koss-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left four networks beginning in 2021",
        },
        {
            name: "Philip Bender",
            position: "Psychologist",
            location: "New York, New York",
            quote: "“The amount of time that you spend waiting on the phone and then they tell you that you’re connected to the wrong place, the wrong person, the wrong department.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Bender-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left a network in 2020",
        },
        {
            name: " Kendra F. Dunlap",
            position: "Therapist",
            location: "Berkeley, California",
            quote: "“Coding errors resulted in unpaid claims, and I spent one to two hours every week to get it resolved. It led to a lot of frustration and took time away from clients.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Dunlap-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left two networks beginning in 2018",
        },
        {
            name: "Kayce Hodos",
            position: "Therapist",
            location: "Wake Forest, North Carolina",
            quote: "“Insurance reimbursement barely covered the gas it took to get to my office.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Hodos-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left five networks beginning in 2017",
        },
        {
            name: "Carter J. Carter",
            position: "Therapist",
            location: "Ashfield, Massachusetts",
            quote: "“You cannot be paid a reasonable wage as a person with an advanced degree.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Carter-Card_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left a network in 2019",
        },
        {
            name: "Rosanne Marmor",
            position: "Therapist",
            location: "Portland, Oregon",
            quote: "“If I make $70 an hour, and I have an office and insurance, then in the end, I was making $30 an hour, and I had a $450 student loan payment. I have a family that needs to eat.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Marmor-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left three networks beginning in 2021",
        },
        {
            name: "Shaina Helm",
            position: "Therapist",
            location: "Chicago, Illinois",
            quote: "“I actually had to get a whole daytime job as a school social worker, because I really cannot afford to rely on insurance companies to pay my bills.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Helm-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left four networks beginning in 2022",
        },

        {
            name: "Marsinah Ramirez Buchan",
            position: "Therapist",
            location: "Bakersfield, California",
            quote: "“With problematic insurers, it takes three, four or five months to get paid, and it’s costing me as a business. I see clients for eight hours and then I spend four hours on the phone with insurers.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Buchan-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left a network in 2023",
        },
        {
            name: "Rhonda Stewart Jones",
            position: "Therapist",
            location: "Alexandria, Virginia",
            quote: "“I am out $20,000-plus, and so it is a very, very big deal. I continued paying my staff, but I was not taking a salary myself.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Stewart-Card-1_maxWidth_3000_maxHeight_3000_ppi_72_quality_95_embedColorProfile_true.jpg",
            leftnetwork: "Left a network in 2020",
        },
        {
            name: "Monika Sharma",
            position: "Psychologist",
            location: "Chicago, Illinois",
            quote: "“I still get letters saying, ‘We’re taking money out of your account.’ I was like, ‘Wait, what? They can just pull money from my bank account?’”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Sharma-Card-1_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left a network in 2021",
        },
        {
            name: "Sarah Mildrum",
            position: "Therapist",
            location: "Windham, Maine",
            quote: "“I was in the place of having to tell my clients they owed me $15,000 or that I would have to eat it, and I ate it.”",
            image: "https://static.propublica.org/projects/graphics/2024-mental-health/WILTN-Mildrum-Card-1jpg_preview_maxWidth_3000_maxHeight_3000_ppi_72_embedColorProfile_true_quality_95.jpg",
            leftnetwork: "Left four networks in 2023",
        },
    ];

    // template for creating provider cards
    const cardTemplate = (
        name,
        location,
        position,
        leftnetwork,
        image,
        quote,
    ) => `
<div class="provider-quote">



<div class="quote">${quote}</div>
</div>
<div class="item-container">
<div class="item">
<div class="card-content">
<div class="provider-name">${name}</div>



<div class="provider-info">
<p class="provider-position">${position}</p>
<p class="provider-location">${location}</p>
</div>
<div class="leftnetwork">${leftnetwork}</div>



</div>
<div class="provider-image">
<img src="${image}" alt="">
</div>
</div>



</div>
`;

    let startingIndex = 0; // i'm tracking the starting index for each section
    let sections = document.querySelectorAll(".cardsSection");

    sections.forEach((sec) => {
        let count = parseInt(sec.getAttribute("data-count"));
        let cont = sec.querySelector(".trigger");

        // then generating cards based on the starting index and count
        // let sectionCards = cardData.slice(startingIndex);

        //if i want to animate ONLY the cards for the relevant section
        let sectionCards = cardData.slice(startingIndex, startingIndex + count);
        sectionCards.forEach((data) => {
            cont.innerHTML += cardTemplate(
                data.name,
                data.location,
                data.position,
                data.leftnetwork,
                data.image,
                data.quote,
            );
        });

        // this updates the starting index for the next section
        startingIndex += count;

        let cardContainers = sec.querySelectorAll(".item-container");
        let cards = sec.querySelectorAll(".item");
        let quotes = sec.querySelectorAll(".provider-quote");

        gsap.set(cards, {
            rotate: (index) => {
                const rand = Math.floor(Math.random() * 2);
                return index === 0 ? 0 : rand * index;
            },
            x: (index) => {
                const rand = Math.floor(Math.random() * 20);
                return index === 0 ? 0 : index + 20;
            },
            y: (index) => {
                const rand = Math.floor(Math.random() * 20);
                return index === 0 ? 0 : index - 20;
            },
            zIndex: (index, target, targets) => targets.length - index,
        });

        gsap.set(quotes, {
            opacity: 0,
        });

        //this is to fix the first quote that wasn't showing up
        gsap.set(quotes[0], { opacity: 1 });

        // sets the initial animation properties for cards
        const startValue = window.innerWidth <= 768 ? "top +50px" : "top 100px"; // leaving extra room <70px since i'm making room for allens subnav
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: sec,
                pin: true,
                start: startValue,
                scrub: true,
                invalidateOnRefresh: true,
                end: isMobile ? "+=1500" : "+=3000",
            },
        });

        const getRandomY = () => Math.floor(Math.random() * 300) + 100; // i'm generating a random number between 100 and 500 so that it looks random
        if (count) {
            cards.forEach((card, index) => {
                if (index < count) {
                    tl.to(card, {
                        x: window.innerWidth,
                        y: getRandomY(),
                        rotate: () => Math.random() * 30 - 2,
                        duration: 1,
                        opacity: 0,
                    })
                        .to(
                            cards[index + 1],
                            {
                                rotate: 0,
                                x: 0,
                                y: 0,
                                duration: 1,
                                opacity: 1,
                            },
                            "<",
                        )
                        .to(
                            quotes[index],
                            {
                                opacity: 0,
                                duration: 0.5,
                            },
                            "<",
                        )
                        .to(
                            quotes[index + 1],
                            {
                                opacity: 1,
                                duration: 0.5,
                            },
                            "<",
                        );
                }
            });
        } else {
            cards.forEach((card, index) => {
                tl.to(card, {
                    x: window.innerWidth,
                    y: getRandomY(),
                    rotate: () => Math.random() * 30 - 2,
                    duration: 1,
                    opacity: 0,
                })
                    .to(
                        cards[index + 1],
                        {
                            rotate: 0,
                            x: 0,
                            y: 0,
                            duration: 1,
                            opacity: 1,
                        },
                        "<",
                    )
                    .to(
                        quotes[index],
                        {
                            opacity: 0,
                            duration: 0.5,
                        },
                        "<",
                    )
                    .to(
                        quotes[index + 1],
                        {
                            opacity: 1,
                            duration: 0.5,
                        },
                        "<",
                    );
            });
        }
    });
}
